import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { Subscription } from 'rxjs';
import { StepsService, StepperConfig } from '../../services/steps.service';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule, StepsModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit, OnDestroy {
  showSteps: boolean = false;
  currentStep: number = 0;
  stepperConfig: StepperConfig = { labels: [], totalSteps: 0 };
  steps: { [key: string]: string } = {};

  private readonly subscriptions: Subscription = new Subscription();

  constructor(private readonly stepsService: StepsService) {}

  ngOnInit() {
    const showStepSubscription = this.stepsService.showStep$.subscribe(
      (showSteps) => {
        this.showSteps = showSteps;
      },
    );
    this.subscriptions.add(showStepSubscription);

    const configSubscription = this.stepsService.stepperConfig$.subscribe(
      (config) => {
        this.stepperConfig = config;
        this.initializeSteps();
      },
    );
    this.subscriptions.add(configSubscription);

    this.getSteps();
  }

  initializeSteps() {
    this.steps = {};
    for (let i = 1; i <= this.stepperConfig.totalSteps; i++) {
      this.steps[`step${i}`] = 'inactive.svg';
    }
  }

  getSteps() {
    const currentStepSubscription = this.stepsService.currentStep$.subscribe(
      (step) => {
        this.currentStep = step;
        this.getStepsStatus(this.currentStep);
      },
    );
    this.subscriptions.add(currentStepSubscription);
  }

  getStepsStatus(current: number) {
    // Reset all steps to inactive
    this.initializeSteps();

    // Only set status if current step is valid (within the range of available steps)
    if (current >= 0 && current <= this.stepperConfig.totalSteps) {
      // Set status based on current step
      for (let i = 1; i <= this.stepperConfig.totalSteps; i++) {
        if (i < current) {
          this.steps[`step${i}`] = 'complete.svg';
        } else if (i === current) {
          this.steps[`step${i}`] = 'active.svg';
        } else {
          this.steps[`step${i}`] = 'inactive.svg';
        }
      }
    }
    // If current step is invalid/unknown, all steps remain inactive (already set by initializeSteps)
  }

  getStepsArray(): number[] {
    return Array.from(
      { length: this.stepperConfig.totalSteps },
      (_, i) => i + 1,
    );
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
